import { useState } from "react";
import BaseInput from "../BaseInput";

const formatCPF = (value) => {
    if (!value) return value;
    const digits = value.replace(/\D/g, "").slice(0, 11);

    if (digits.length <= 3) {
        return digits;
    } else if (digits.length <= 6) {
        return `${digits.slice(0, 3)}.${digits.slice(3)}`;
    } else if (digits.length <= 9) {
        return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    } else {
        return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
    }
};

const CPFInput = ({ value, onInput, label = 'CPF', placeholder = '000.000.000-00', variant = 'light', ...props }) => {
    const [localValue, setLocalValue] = useState(value ? formatCPF(value) : "");

    const handleChange = (newValue) => {
        const digits = newValue.replace(/\D/g, "").slice(0, 11);
        const displayValue = formatCPF(digits);
        setLocalValue(displayValue);
        onInput(digits);
    };

    return (
        <BaseInput
            {...props}
            value={localValue}
            onInput={handleChange}
            label={label}
            placeholder={placeholder}
            variant={variant}
            maxLength={14}
        />
    );
};

export default CPFInput;
